import { render, staticRenderFns } from "./OAuth.vue?vue&type=template&id=98a5c4d0&"
import script from "./OAuth.vue?vue&type=script&lang=ts&"
export * from "./OAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports